/**
 * Build-time stub. The Vite alias in `vite.config.ts` redirects every
 * `@/prototypes/*` import to this file in production, so prototype code
 * never lands in the production bundle.
 *
 * If you see this file referenced at runtime in dev, something is wrong
 * with the alias config — `import.meta.env.DEV` should be true and the
 * real prototypes module should be loaded.
 */

import type { ComponentType } from "react";

const NoopComponent: ComponentType = () => null;

export const PrototypesIndex: ComponentType = NoopComponent;
export const RoomsListVariantA: ComponentType = NoopComponent;
export const RoomsListVariantB: ComponentType = NoopComponent;
export const RoomsListVariantC: ComponentType = NoopComponent;
export const RoomCreateVariantA: ComponentType = NoopComponent;
export const RoomCreateVariantB: ComponentType = NoopComponent;
export const RoomCreateVariantC: ComponentType = NoopComponent;
export const MargauxPromptVariantA: ComponentType = NoopComponent;
export const MargauxPromptVariantB: ComponentType = NoopComponent;
export const MargauxPromptVariantC: ComponentType = NoopComponent;

// Phase 2 — organizer cockpit prototypes
export const MultiClubHomeVariantV1: ComponentType = NoopComponent;
export const MultiClubHomeVariantV2: ComponentType = NoopComponent;
export const MultiClubHomeVariantV3: ComponentType = NoopComponent;
export const ClubHomeVariantV1: ComponentType = NoopComponent;
export const ClubHomeVariantV2: ComponentType = NoopComponent;
export const ClubHomeVariantV3: ComponentType = NoopComponent;
export const GatheringsVariantV1: ComponentType = NoopComponent;
export const GatheringsVariantV2: ComponentType = NoopComponent;
export const GatheringsVariantV3: ComponentType = NoopComponent;
export const VotingVariantV1: ComponentType = NoopComponent;
export const VotingVariantV2: ComponentType = NoopComponent;
export const VotingVariantV3: ComponentType = NoopComponent;
export const RoomCreateVariantV1: ComponentType = NoopComponent;
export const RoomCreateVariantV2: ComponentType = NoopComponent;
export const RoomCreateVariantV3: ComponentType = NoopComponent;
export const FacilitatorVariantV1: ComponentType = NoopComponent;
export const FacilitatorVariantV2: ComponentType = NoopComponent;
export const FacilitatorVariantV3: ComponentType = NoopComponent;
export const MarketingVariantV1: ComponentType = NoopComponent;
export const MarketingVariantV2: ComponentType = NoopComponent;
export const MarketingVariantV3: ComponentType = NoopComponent;
export const DiscoverVariantV1: ComponentType = NoopComponent;
export const DiscoverVariantV2: ComponentType = NoopComponent;
export const DiscoverVariantV3: ComponentType = NoopComponent;
export const GatheringDetailVariantV1: ComponentType = NoopComponent;
export const GatheringDetailVariantV2: ComponentType = NoopComponent;
export const GatheringDetailVariantV3: ComponentType = NoopComponent;
export const WelcomeHubVariantV1: ComponentType = NoopComponent;
export const WelcomeHubVariantV2: ComponentType = NoopComponent;
export const WelcomeHubVariantV3: ComponentType = NoopComponent;
export const UserMenuVariantV1: ComponentType = NoopComponent;
export const UserMenuVariantV2: ComponentType = NoopComponent;
export const UserMenuVariantV3: ComponentType = NoopComponent;

// Mock data is intentionally empty in production builds.
export const mockUsers: never[] = [];
export const mockRooms: never[] = [];
export const mockMargauxPosts: never[] = [];
export const mockClubs: never[] = [];
export const mockGatherings: never[] = [];
export const mockVotingNominations: never[] = [];
export const mockMemberProgress: never[] = [];
export const mockPromptHistory = {
  promptId: "",
  name: "",
  entries: [] as never[],
};
